import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: '漯河市总工会',
        },
        component: () => import('../views/home/index.vue'),
      },
      {
        path: '/staff/service',
        name: 'staffService',
        meta: {
          title: '职工服务平台',
        },
        component: () => import('../views/staff/index.vue'),
      },          
      {
        path: '/know/:type',
        name: 'know',
        meta: {
          title: '资讯列表'
        },
        component: () => import('../views/know/index.vue')
      },
      {
        path: '/unit/consult',
        name: 'unitConsult',
        meta: {
          title: '部门资讯',
        },
        component: () => import('../views/unit/index.vue')
      },
      {
        path: '/newsDetails/:type/:id/:catalogId',
        name: 'newsDetails',
        meta: {
          title: '资讯详情',
          activeMenu: ''
        },
        component: () => import('../views/newsDetails/detail.vue')
      },
      {
        path: '/column/:type',
        name: 'column',
        meta: {
          title: '栏目'
        },
        component: () => import('../views/column/index.vue')
      },
      {
        path: '/columnDetail/:type/:id',
        name: 'columnDetail',
        meta: {
          title: '栏目详情'
        },
        component: () => import('../views/newsDetails/index.vue')
      }      
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.afterEach((to, from, next) => {
  if (/detail/gi.test(to.name)) {
    document.documentElement.scrollTop = 0
  }
})


export default router
